import React from "react";
import "./BillingDetails.scss";
import OverflowTooltip from "../pages/subscription/OverflowTooltip";

const BillingPlan = ({ plan }) => {
  return (
    <div className="billing-plan">
      <p>Billing cycle <span>{plan.interval_unit=="months"?"Monthly":"Yearly"}</span></p>
      <p>Price <span>{plan.price}</span></p>
      <p>Plan description <span className="plan-description"><OverflowTooltip text={plan.description} /></span></p>
    </div>
  );
};

const BillingDetails = ({ plans }) => {
  return (
    <div className="billing-details">
      <h2 className="billing-title">Billing details</h2>
      <BillingPlan  plan={plans.mbill} />
      <BillingPlan  plan={plans.ybill} />
    </div>
  );
};

export default BillingDetails;
